import { FC } from 'react';
import { LocalizedButton } from 'shared/ui/localized-button';
import { LocalizedText } from 'shared/ui/localized-text';
import { LocalizedHeading } from 'shared/ui/localized-heading';
import { EnterprisePortalLayout } from 'shared/ui/portal-layout';
import { browserList } from '../config/constants';
import { BrowserItem } from './BrowserItem';
import { StyledSpace, StyledUl } from './styled';

export const UnsupportedBrowser: FC<{ onSkipWarning: () => void }> = ({
    onSkipWarning: onClick,
}) => (
    <EnterprisePortalLayout>
        <StyledSpace align="start" direction="vertical" gap={16}>
            <LocalizedHeading localizationKey="UnsupportedBrowser.NoticeTitle" type="H5" />
            <LocalizedHeading localizationKey="UnsupportedBrowser.UsingOldBrowser" type="H6" />
            <LocalizedText localizationKey="UnsupportedBrowser.PleaseUpdate" type="BTM2" />
            <StyledUl>
                {browserList.map(({ browser, url }) => (
                    <BrowserItem key={browser} browser={browser} url={url} />
                ))}
            </StyledUl>
            <LocalizedButton localizationKey="UnsupportedBrowser.Continue" onClick={onClick} />
        </StyledSpace>
    </EnterprisePortalLayout>
);
